import { useEffect, useState, useCallback, useRef } from "react";
import { useRoomPermissions } from "./useRoomPermissions";
import { getMicrophonePresences } from "../../utils/microphone-presence";
import isEqual from "lodash/isEqual";

export function userFromPresence(sessionId, presence, micPresences, mySessionId, voiceEnabled) {
  const meta = presence.metas[presence.metas.length - 1];
  const micPresence = micPresences.has(sessionId) ? { ...micPresences.get(sessionId) } : undefined;

  if (micPresence && !voiceEnabled && !meta.permissions.voice_chat) {
    micPresence.muted = true;
  }

  return {
    id: sessionId,
    isMe: mySessionId === sessionId,
    micPresence,
    ...meta
  };
}

export function usePeopleList(presences, mySessionId, micUpdateFrequency = 1000) {
  const [people, setPeople] = useState([]);
  const { voice_chat: voiceChatEnabled } = useRoomPermissions();
  const timeoutRef = useRef(null);

  const calculatePeopleList = useCallback(() => {
    if (!presences) {
      return [];
    }

    const micPresences = getMicrophonePresences();

    const newPeopleList = Object.entries(presences)
      .map(([id, presence]) => {
        if (!presence || !Array.isArray(presence.metas) || presence.metas.length === 0) {
          console.warn(`Invalid presence structure for ID: ${id}`);
          return null;
        }
        return userFromPresence(id, presence, micPresences, mySessionId, voiceChatEnabled);
      })
      .filter(p => p !== null);

    return newPeopleList;
  }, [presences, mySessionId, voiceChatEnabled]);

  useEffect(() => {
    const performUpdate = () => {
      const newPeopleList = calculatePeopleList();

      setPeople(currentPeople => {
        if (!isEqual(currentPeople, newPeopleList)) {
          return newPeopleList;
        }
        return currentPeople;
      });

      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }
      timeoutRef.current = setTimeout(performUpdate, micUpdateFrequency);
    };

    performUpdate();

    return () => {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
        timeoutRef.current = null;
      }
    };
  }, [calculatePeopleList, micUpdateFrequency]);

  return people;
}
